export default __webpack_public_path__ + "static/media/promo-retro-bot.5ffabd73.png";